if (!window.__megaMenuInitialized) {
  window.__megaMenuInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    initMegaMenu();
  });

  function initMegaMenu() {
    const triggers = document.querySelectorAll(".js-open-megamenu");
    const items = document.querySelectorAll(".js-megamenu-item");
    const closeButtons = document.querySelectorAll(".js-close-megamenu");
    const megaMenuLinks = document.querySelectorAll(".js-megamenu-link");
    const mobileMenuToggleButtons = document.querySelectorAll(".js-toggle-mobile-menu");
    const mobileMenus = document.querySelectorAll(".js-mobile-menu");
    const megaMenus = document.querySelectorAll(".js-megamenu");
    const mobileInitialStep = document.querySelector(".js-mobile-initial-step");
    const body = document.body;

    if (!triggers.length || !items.length) return;

    let activeItem = null;
    let activeSubmenu = null;
    let isSubmenuTransitioning = false;
    let isMenuTransitioning = false;
    let isSwitchingMenu = false;
    let isMobileMenuOpened = false;
    let isMobileMenuAnimating = false;
    let activeTrigger = null;

    moveSubmenusToMegamenuItem();
    markTriggersWithSubmenu();
    addBackButtonsToSubmenus();
    addBackButtonsToMegamenuItems();
    bindSubmenuBackButtons();
    bindMegamenuBackButtons();
    bindMobileMenuToggle();
    bindShopifyEditorEvents();

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        const index = trigger.dataset.index;
        if (!index || isMenuTransitioning) return;

        const target = document.querySelector(`.js-megamenu-item[data-index="${index}"]`);
        if (!target) return;

        if (activeItem === target) {
          const allowNavigate = trigger.closest('[data-navigate-on-second-click="true"]');
          const href = trigger.getAttribute("href");
          if (allowNavigate && href && href !== "#") {
            return;
          }
        }

        e.preventDefault();

        if (activeTrigger && activeTrigger !== trigger) {
          activeTrigger.classList.remove("active");
        }

        trigger.classList.add("active");
        activeTrigger = trigger;

        if (isMobileView()) {
          if (!isMobileMenuOpened) return;

          if (activeItem === target) {
            return;
          }

          openMobileMegamenuFromInitialStep(target);
          return;
        }

        if (activeItem === target) {
          return;
        }

        if (!activeItem) {
          openItem(target);
          activeItem = target;
          lockScroll();
          return;
        }

        isMenuTransitioning = true;
        isSwitchingMenu = true;
        body.classList.add("is-switching-megamenu");

        closeActiveItem(() => {
          openItem(target);
          activeItem = target;

          setTimeout(() => {
            isSwitchingMenu = false;
            body.classList.remove("is-switching-megamenu");
            isMenuTransitioning = false;
          }, 50);
        });
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        if (isMobileView()) {
          return;
        }

        if (isMenuTransitioning) return;
        closeMegaMenu();
      });
    });

    megaMenuLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const blockId = link.dataset.blockId;
        if (!blockId || isSubmenuTransitioning) return;

        const submenu = document.querySelector(`.js-submenu[data-block-id="${blockId}"]`);
        if (!submenu) return;

        e.preventDefault();

        if (activeSubmenu === submenu) {
          closeSubmenu(submenu);
          return;
        }

        if (activeSubmenu) {
          isSubmenuTransitioning = true;

          if (isMobileView()) {
            switchSubmenuMobile(activeSubmenu, submenu, () => {
              isSubmenuTransitioning = false;
            });
          } else {
            const previousSubmenu = activeSubmenu;

            closeSubmenu(previousSubmenu, () => {
              openSubmenu(submenu);
              isSubmenuTransitioning = false;
            });
          }

          return;
        }

        openSubmenu(submenu);
      });
    });

    document.addEventListener("click", (e) => {
      if (isMobileView()) return;
      if (!activeItem || isMenuTransitioning) return;

      const isTrigger = e.target.closest(".js-open-megamenu");
      const isInsideMenu = e.target.closest(".js-megamenu-item");

      if (!isTrigger && !isInsideMenu) {
        closeMegaMenu();
      }
    });

    function isMobileView() {
      return window.innerWidth < 992;
    }

    function moveSubmenusToMegamenuItem() {
      megaMenuLinks.forEach((link) => {
        const parent = link.parentElement;
        if (!parent) return;

        const submenu = parent.querySelector(".js-submenu");
        if (!submenu) return;

        link.classList.add("with-submenu");

        const blockId = link.dataset.blockId;
        if (blockId) {
          submenu.dataset.blockId = blockId;
        }

        const megamenuItem = link.closest(".js-megamenu-item");
        if (!megamenuItem) return;

        megamenuItem.appendChild(submenu);
      });
    }

    function markTriggersWithSubmenu() {
      triggers.forEach((trigger) => {
        const index = trigger.dataset.index;
        if (!index) return;

        const target = document.querySelector(`.js-megamenu-item[data-index="${index}"]`);
        if (!target) return;

        const hasSubmenu =
          target.querySelector(".js-megamenu-link") ||
          target.querySelector(".js-submenu");

        if (hasSubmenu) {
          trigger.classList.add("with-submenu");
        }
      });
    }

    function addBackButtonsToSubmenus() {
      const submenus = document.querySelectorAll(".js-submenu");

      submenus.forEach((submenu) => {
        if (submenu.querySelector(".js-submenu-back")) return;

        const backButton = document.createElement("button");
        backButton.type = "button";
        backButton.className = "text-cta js-submenu-back";
        backButton.setAttribute("aria-label", "Back");
        backButton.innerHTML = "Back";

        submenu.prepend(backButton);
      });
    }

    function addBackButtonsToMegamenuItems() {
      items.forEach((item) => {
        if (item.querySelector(".js-megamenu-back") || !item.querySelector(".megamenu-item__content")) return;

        const backButton = document.createElement("button");
        backButton.type = "button";
        backButton.className = "text-cta js-megamenu-back";
        backButton.setAttribute("aria-label", "Back");
        backButton.innerHTML = "Back";

        item.querySelector(".megamenu-item__content").prepend(backButton);
      });
    }

    function bindSubmenuBackButtons() {
      document.addEventListener("click", (e) => {
        const backButton = e.target.closest(".js-submenu-back");
        if (!backButton) return;
        if (isSubmenuTransitioning) return;

        const submenu = backButton.closest(".js-submenu");
        if (!submenu) return;

        e.preventDefault();
        closeSubmenu(submenu);
      });
    }

    function bindMegamenuBackButtons() {
      document.addEventListener("click", (e) => {
        const backButton = e.target.closest(".js-megamenu-back");
        if (!backButton) return;
        if (!isMobileView()) return;
        if (isMenuTransitioning || isSubmenuTransitioning) return;

        e.preventDefault();
        returnToMobileInitialStep();
      });
    }

    function bindMobileMenuToggle() {
      mobileMenuToggleButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          if (!isMobileView()) return;
          if (isMobileMenuAnimating) return;

          e.preventDefault();

          const shouldOpen = !button.classList.contains("active");

          if (shouldOpen) {
            openMobileMenu();
          } else {
            closeMobileMenu();
          }
        });
      });
    }

    function openMobileMenu() {
      if (!isMobileView() || isMobileMenuAnimating) return;

      isMobileMenuAnimating = true;

      mobileMenuToggleButtons.forEach((button) => {
        button.classList.add("active");
      });

      mobileMenus.forEach((menu) => {
        clearMobileMenuAnimationClasses(menu);
        menu.classList.add("active", "is-entering-right");
        menu.offsetHeight;

        requestAnimationFrame(() => {
          menu.classList.remove("is-entering-right");
        });
      });

      if (mobileInitialStep) {
        clearInitialStepAnimationClasses(mobileInitialStep);
        mobileInitialStep.classList.add("active");
      }

      megaMenus.forEach((menu) => {
        clearMegaMenuAnimationClasses(menu);
        menu.classList.remove("active", "is-entering-right", "is-leaving-left");
      });

      resetAllMobileMegamenuStates();

      body.classList.add("mobile-menu-open");
      body.classList.remove("with-opened-megamenu");

      isMobileMenuOpened = true;
      lockScroll();

      setTimeout(() => {
        isMobileMenuAnimating = false;
      }, 300);
    }

    function closeMobileMenu() {
      if (!isMobileView() || isMobileMenuAnimating) return;

      isMobileMenuAnimating = true;

      mobileMenuToggleButtons.forEach((button) => {
        button.classList.remove("active");
      });

      const currentItem = activeItem;
      const currentSubmenu = activeSubmenu;

      mobileMenus.forEach((menu) => {
        clearMobileMenuAnimationClasses(menu);
        menu.classList.add("active", "is-leaving-left");
      });

      megaMenus.forEach((menu) => {
        clearMegaMenuAnimationClasses(menu);
        menu.classList.remove("is-entering-right");
        menu.classList.add("active", "is-leaving-left");
      });

      if (currentItem) {
        clearMobileAnimationClasses(currentItem);
        currentItem.classList.remove("is-entering-right");
        currentItem.classList.add("show", "active");
      }

      if (currentSubmenu) {
        clearSubmenuAnimationClasses(currentSubmenu);
        currentSubmenu.classList.remove("is-entering-right");
        currentSubmenu.classList.add("show", "active");
      }

      if (mobileInitialStep) {
        clearInitialStepAnimationClasses(mobileInitialStep);
        mobileInitialStep.classList.remove("active");
      }

      setTimeout(() => {
        mobileMenus.forEach((menu) => {
          menu.classList.remove("active", "is-leaving-left");
          clearMobileMenuAnimationClasses(menu);
        });

        megaMenus.forEach((menu) => {
          menu.classList.remove("active", "is-leaving-left", "is-entering-right");
          clearMegaMenuAnimationClasses(menu);
        });

        resetAllMobileMegamenuStates();

        if (mobileInitialStep) {
          clearInitialStepAnimationClasses(mobileInitialStep);
          mobileInitialStep.classList.add("active");
        }

        body.classList.remove("mobile-menu-open");
        body.classList.remove("with-opened-megamenu");

        isMobileMenuOpened = false;
        unlockScroll(true);
        isMobileMenuAnimating = false;
      }, 300);
    }

    function resetAllMobileMegamenuStates() {
      if (activeSubmenu) {
        clearSubmenuAnimationClasses(activeSubmenu);
        activeSubmenu.classList.remove(
          "show",
          "active",
          "deactivate",
          "is-entering-right",
          "is-leaving-left",
          "is-closing"
        );
      }

      items.forEach((item) => {
        clearMobileAnimationClasses(item);
        item.classList.remove(
          "show",
          "active",
          "deactivate",
          "deactivate-with-submenu",
          "submenu-active",
          "submenu-returning"
        );
      });

      document.querySelectorAll(".js-submenu").forEach((submenu) => {
        clearSubmenuAnimationClasses(submenu);
        submenu.classList.remove(
          "show",
          "active",
          "deactivate",
          "is-entering-right",
          "is-leaving-left",
          "is-closing"
        );
      });

      activeItem = null;
      activeSubmenu = null;
    }

    function openMobileMegamenuFromInitialStep(target) {
      if (!target || !isMobileView()) return;

      isMenuTransitioning = true;

      if (mobileInitialStep) {
        clearInitialStepAnimationClasses(mobileInitialStep);
        mobileInitialStep.classList.add("active");
        mobileInitialStep.offsetHeight;

        requestAnimationFrame(() => {
          mobileInitialStep.classList.add("is-leaving-left");
        });
      }

      megaMenus.forEach((menu) => {
        clearMegaMenuAnimationClasses(menu);
        menu.classList.add("active", "is-entering-right");
        menu.offsetHeight;

        requestAnimationFrame(() => {
          menu.classList.remove("is-entering-right");
        });
      });

      openItem(target);
      activeItem = target;
      body.classList.add("with-opened-megamenu");

      setTimeout(() => {
        if (mobileInitialStep) {
          mobileInitialStep.classList.remove("active");
          mobileInitialStep.classList.remove("is-leaving-right");
          mobileInitialStep.classList.add("is-hidden-left");
        }

        isMenuTransitioning = false;
      }, 300);
    }

    function returnToMobileInitialStep() {
      if (!isMobileView()) return;
      if (!activeItem) return;
      if (isMenuTransitioning || isSubmenuTransitioning) return;

      isMenuTransitioning = true;

      const currentItem = activeItem;
      const currentSubmenu = activeSubmenu;

      if (currentSubmenu) {
        clearSubmenuAnimationClasses(currentSubmenu);
        currentSubmenu.classList.remove("active");
        currentSubmenu.classList.add("is-closing");
      }

      clearMobileAnimationClasses(currentItem);
      currentItem.classList.remove("submenu-active", "submenu-returning");
      currentItem.classList.add("show", "active");

      megaMenus.forEach((menu) => {
        clearMegaMenuAnimationClasses(menu);
        menu.classList.add("active", "is-leaving-right");
      });

      if (mobileInitialStep) {
        clearInitialStepAnimationClasses(mobileInitialStep);
        mobileInitialStep.classList.remove("active");
        mobileInitialStep.classList.add("is-hidden-left");
        mobileInitialStep.offsetHeight;

        requestAnimationFrame(() => {
          mobileInitialStep.classList.add("active");
          mobileInitialStep.classList.remove("is-hidden-left");
        });
      }

      setTimeout(() => {
        if (currentSubmenu) {
          currentSubmenu.classList.remove(
            "show",
            "active",
            "deactivate",
            "is-entering-right",
            "is-leaving-left",
            "is-closing"
          );
        }

        currentItem.classList.remove(
          "show",
          "active",
          "deactivate",
          "deactivate-with-submenu",
          "submenu-active",
          "submenu-returning",
          "is-entering-right",
          "is-leaving-left",
          "is-closing"
        );

        megaMenus.forEach((menu) => {
          menu.classList.remove("active", "is-leaving-left", "is-leaving-right", "is-entering-right");
          clearMegaMenuAnimationClasses(menu);
        });

        if (mobileInitialStep) {
          clearInitialStepAnimationClasses(mobileInitialStep);
          mobileInitialStep.classList.add("active");
        }

        body.classList.remove("with-opened-megamenu");
        activeSubmenu = null;
        activeItem = null;
        isMenuTransitioning = false;
      }, 300);
    }

    function clearMegaMenuAnimationClasses(menu) {
      if (!menu) return;

      menu.classList.remove(
        "is-entering-right",
        "is-leaving-left",
        "is-leaving-right"
      );
    }

    function clearMobileMenuAnimationClasses(menu) {
      if (!menu) return;

      menu.classList.remove("is-entering-right", "is-leaving-left");
    }

    function clearInitialStepAnimationClasses(step) {
      if (!step) return;

      step.classList.remove(
        "is-hidden-left",
        "is-hidden-right",
        "is-leaving-left",
        "is-leaving-right"
      );
    }

    function clearMobileAnimationClasses(item) {
      if (!item) return;

      item.classList.remove(
        "is-entering-right",
        "is-leaving-left",
        "is-closing"
      );
    }

    function clearSubmenuAnimationClasses(submenu) {
      if (!submenu) return;

      submenu.classList.remove(
        "is-entering-right",
        "is-leaving-left",
        "is-closing"
      );
    }

    function openItem(item) {
      clearMobileAnimationClasses(item);
      item.classList.remove("submenu-active", "submenu-returning");
      item.classList.add("show");

      if (isMobileView()) {
        item.classList.add("is-entering-right");
        item.offsetHeight;

        requestAnimationFrame(() => {
          item.classList.add("active");
          item.classList.remove("deactivate", "deactivate-with-submenu");
          item.classList.remove("is-entering-right");
        });
      } else {
        item.offsetHeight;
        item.classList.add("active");
        item.classList.remove("deactivate", "deactivate-with-submenu");
      }

      body.classList.add("with-opened-megamenu");
    }

    function openSubmenu(submenu) {
      if (!submenu || !activeItem) return;

      if (isMobileView()) {
        clearSubmenuAnimationClasses(submenu);

        submenu.classList.add("show", "is-entering-right");
        activeItem.classList.remove("submenu-returning");
        submenu.offsetHeight;
        activeItem.offsetHeight;

        activeItem.classList.add("submenu-active");

        requestAnimationFrame(() => {
          submenu.classList.add("active");
          submenu.classList.remove("is-entering-right");
        });

        activeSubmenu = submenu;
        return;
      }

      submenu.classList.remove("deactivate");
      submenu.classList.add("show");
      submenu.offsetHeight;
      submenu.classList.add("active");
      activeSubmenu = submenu;
    }

    function closeSubmenu(submenu, callback) {
      if (!submenu) {
        if (typeof callback === "function") callback();
        return;
      }

      if (isMobileView()) {
        clearSubmenuAnimationClasses(submenu);

        submenu.classList.remove("active");
        submenu.classList.add("is-closing");

        if (activeItem) {
          activeItem.classList.remove("submenu-active");
          activeItem.classList.add("submenu-returning");
        }

        setTimeout(() => {
          submenu.classList.remove(
            "show",
            "is-closing",
            "is-entering-right",
            "is-leaving-left"
          );

          if (activeItem) {
            activeItem.classList.remove("submenu-returning");
          }

          if (activeSubmenu === submenu) {
            activeSubmenu = null;
          }

          if (typeof callback === "function") {
            callback();
          }
        }, 300);

        return;
      }

      submenu.classList.remove("active");
      submenu.classList.add("deactivate");

      setTimeout(() => {
        submenu.classList.remove("show", "deactivate");

        if (activeSubmenu === submenu) {
          activeSubmenu = null;
        }

        if (typeof callback === "function") {
          callback();
        }
      }, 300);
    }

    function closeActiveItem(callback) {
      if (!activeItem) {
        if (typeof callback === "function") callback();
        return;
      }

      const currentItem = activeItem;
      const currentSubmenu = activeSubmenu;
      const hadOpenSubmenu = !!currentSubmenu;

      currentItem.classList.remove("submenu-active", "submenu-returning");
      clearMobileAnimationClasses(currentItem);

      currentItem.classList.remove("active");
      currentItem.classList.add("deactivate");

      if (hadOpenSubmenu) {
        currentItem.classList.add("deactivate-with-submenu");
      } else {
        currentItem.classList.remove("deactivate-with-submenu");
      }

      if (currentSubmenu) {
        currentSubmenu.classList.remove("active");
        currentSubmenu.classList.add("deactivate");

        setTimeout(() => {
          currentSubmenu.classList.remove("show", "deactivate");
        }, 300);

        activeSubmenu = null;
      }

      setTimeout(() => {
        currentItem.classList.remove(
          "show",
          "deactivate",
          "deactivate-with-submenu"
        );
        clearMobileAnimationClasses(currentItem);
        activeItem = null;

        if (typeof callback === "function") {
          callback();
        }
      }, 300);
    }

    function switchItemsMobile(currentItem, nextItem, callback) {
      const currentSubmenu = activeSubmenu;

      if (currentSubmenu) {
        currentSubmenu.classList.remove("active");
        currentSubmenu.classList.add("deactivate");

        setTimeout(() => {
          currentSubmenu.classList.remove("show", "deactivate");
        }, 300);

        activeSubmenu = null;
      }

      clearMobileAnimationClasses(currentItem);
      clearMobileAnimationClasses(nextItem);

      currentItem.classList.remove("submenu-active", "submenu-returning");
      nextItem.classList.remove("submenu-active", "submenu-returning");

      nextItem.classList.add("show", "is-entering-right");
      nextItem.offsetHeight;

      currentItem.classList.remove("active");
      currentItem.classList.add("is-leaving-left");

      requestAnimationFrame(() => {
        nextItem.classList.add("active");
      });

      setTimeout(() => {
        currentItem.classList.remove(
          "show",
          "active",
          "deactivate",
          "deactivate-with-submenu",
          "is-leaving-left",
          "is-closing",
          "is-entering-right"
        );

        nextItem.classList.remove("is-entering-right");
        nextItem.classList.add("show", "active");

        if (typeof callback === "function") {
          callback();
        }
      }, 300);
    }

    function switchSubmenuMobile(currentSubmenu, nextSubmenu, callback) {
      if (!currentSubmenu || !nextSubmenu) {
        if (typeof callback === "function") callback();
        return;
      }

      clearSubmenuAnimationClasses(currentSubmenu);
      clearSubmenuAnimationClasses(nextSubmenu);

      nextSubmenu.classList.add("show", "is-entering-right");
      nextSubmenu.offsetHeight;

      currentSubmenu.classList.remove("active");
      currentSubmenu.classList.add("is-leaving-left");

      requestAnimationFrame(() => {
        nextSubmenu.classList.add("active");
      });

      setTimeout(() => {
        currentSubmenu.classList.remove(
          "show",
          "active",
          "is-leaving-left",
          "is-entering-right",
          "is-closing"
        );

        nextSubmenu.classList.remove("is-entering-right");
        nextSubmenu.classList.add("show", "active");

        activeSubmenu = nextSubmenu;

        if (typeof callback === "function") {
          callback();
        }
      }, 300);
    }

    function closeMegaMenu() {
      if (isMobileView()) {
        return;
      }

      if (!activeItem || isMenuTransitioning) return;

      isMenuTransitioning = true;

      closeActiveItem(() => {
        body.classList.remove("with-opened-megamenu");
        body.classList.remove("is-switching-megamenu");

        if (activeTrigger) {
          activeTrigger.classList.remove("active");
          activeTrigger = null;
        }
            
        isSwitchingMenu = false;
        unlockScroll();
        isMenuTransitioning = false;
      });
    }

    function openMegaMenuByIndex(index, callback) {
      if (!index) {
        if (typeof callback === "function") callback();
        return;
      }

      const target = document.querySelector(`.js-megamenu-item[data-index="${index}"]`);
      if (!target) {
        if (typeof callback === "function") callback();
        return;
      }

      if (isMobileView()) {
        if (mobileInitialStep) {
          mobileInitialStep.classList.remove("active");
        }

        megaMenus.forEach((menu) => {
          menu.classList.add("active");
        });

        openItem(target);
        activeItem = target;

        if (typeof callback === "function") callback();
        return;
      }

      if (activeItem === target) {
        if (typeof callback === "function") callback();
        return;
      }

      if (!activeItem) {
        openItem(target);
        activeItem = target;
        lockScroll();

        if (typeof callback === "function") callback();
        return;
      }

      isMenuTransitioning = true;
      isSwitchingMenu = true;
      body.classList.add("is-switching-megamenu");

      closeActiveItem(() => {
        openItem(target);
        activeItem = target;

        setTimeout(() => {
          isSwitchingMenu = false;
          body.classList.remove("is-switching-megamenu");
          isMenuTransitioning = false;

          if (typeof callback === "function") {
            callback();
          }
        }, 50);
      });
    }

    function openSubmenuByBlockId(blockId) {
      if (!blockId) return;

      const submenu = document.querySelector(`.js-submenu[data-block-id="${blockId}"]`);
      if (!submenu) return;

      if (activeSubmenu === submenu) return;

      if (!activeSubmenu) {
        openSubmenu(submenu);
        return;
      }

      isSubmenuTransitioning = true;

      if (isMobileView()) {
        switchSubmenuMobile(activeSubmenu, submenu, () => {
          isSubmenuTransitioning = false;
        });
      } else {
        closeSubmenu(activeSubmenu, () => {
          openSubmenu(submenu);
          isSubmenuTransitioning = false;
        });
      }
    }

    function bindShopifyEditorEvents() {
      if (typeof Shopify === "undefined" || !Shopify.designMode) return;

      document.addEventListener("shopify:block:select", (event) => {
        if (isMenuTransitioning || isSubmenuTransitioning) return;

        const blockElement = event.target;
        if (!blockElement) return;

        const trigger =
          blockElement.matches(".js-open-megamenu")
            ? blockElement
            : blockElement.querySelector(".js-open-megamenu");

        if (trigger) {
          const index = trigger.dataset.index;
          if (!index) return;

          openMegaMenuByIndex(index);
          return;
        }

        const megaMenuLink =
          blockElement.matches(".js-megamenu-link")
            ? blockElement
            : blockElement.querySelector(".js-megamenu-link");

        if (megaMenuLink) {
          const blockId = megaMenuLink.dataset.blockId;
          if (!blockId) return;

          const parentMenuItem = megaMenuLink.closest(".js-megamenu-item");
          const index = parentMenuItem?.dataset.index;

          openMegaMenuByIndex(index, () => {
            openSubmenuByBlockId(blockId);
          });

          return;
        }

        const rawBlockId =
          blockElement.dataset.blockId ||
          blockElement.querySelector("[data-block-id]")?.dataset.blockId;

        if (rawBlockId) {
          const submenu = document.querySelector(`.js-submenu[data-block-id="${rawBlockId}"]`);
          if (!submenu) return;

          const parentMenuItem = submenu.closest(".js-megamenu-item");
          const index = parentMenuItem?.dataset.index;

          openMegaMenuByIndex(index, () => {
            openSubmenuByBlockId(rawBlockId);
          });
        }
      });

      document.addEventListener("shopify:section:load", () => {
        moveSubmenusToMegamenuItem();
        addBackButtonsToSubmenus();
        addBackButtonsToMegamenuItems();
      });
    }

    function lockScroll() {
      if (window.lenis) {
        window.lenis.stop();
      } else {
        document.body.style.overflow = "hidden";
      }
    }

    function unlockScroll(force = false) {
      if (window.innerWidth < 992 && !force) return;

      if (window.lenis) {
        window.lenis.start();
      } else {
        document.body.style.overflow = "";
      }
    }
  }
}